import React from "react";
import { ConditionalWrapper } from "./conditional-wrapper";
import clsx from "clsx";
import { SkewedTextBox } from "./SkewedTextBox";

interface GalleryProps {
  children: React.ReactNode;
}

export function Gallery(props: GalleryProps) {
  return (
    <div className="flex -mx-[46px]">
      {props.children}
    </div>
  );
}

interface GalleryItemProps {
  title: string;
  image: string;
  color: string;
  link?: string;
  children?: React.ReactNode;
}

export function GalleryItem(props: GalleryItemProps) {
  const tileContent = (
    <div className="relative h-full w-full">
      <div
        className="h-full mx-[-30px] skew-x-[7.125deg] bg-cover bg-center transition-transform duration-300"
        style={{ backgroundImage: `url(${props.image})` }}
      />
      <div className={clsx(
        "gallery-overlay absolute inset-0 z-[100] flex flex-col items-center justify-center bg-black/25 p-2 text-white opacity-0 transition-opacity duration-300"
        )}>
          <div className="skew-x-[7.125deg]">

        <SkewedTextBox
          variant="h6"
          component="div"
          color="theme"
          align="center"
          >
          {props.title}
        </SkewedTextBox>
          </div>
        {props.children}
      </div>
    </div>
  );

  return (
    <div
      tabIndex={0}
      className={clsx("relative h-[480px] flex-1 overflow-hidden border-0 -skew-x-[7.125deg] transition-[flex] duration-300 ease-in-out hover:flex-[3.5] focus-visible:flex-[3.5] [&:hover_.gallery-overlay]:opacity-100 [&:focus-visible_.gallery-overlay]:opacity-100",
        "focus-visible:outline-none",
        "focus-visible:ring focus-visible:ring-foreground focus-visible:ring-offset-4 focus-visible:ring-offset-page ring-contrast focus-visible:z-20",
      )}
      style={{ backgroundColor: props.color }}
    >
      <ConditionalWrapper
        condition={Boolean(props.link)}
        wrapper={(children) => (
          <a href={props.link} target="_blank" rel="noopener noreferrer" className="block h-full">
            {children}
          </a>
        )}
      >
        {tileContent}
      </ConditionalWrapper>
    </div>
  );
}
